import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  AgePricingCreateDto,
  AgePricingUpdateDto,
} from '../dtos/agePricing/agePricingDto';

@Injectable({
  providedIn: 'root',
})
export class AgePricingService {
  private apiUrl = `${environment.apiUrl}/agePricing`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  create(agePricing: AgePricingCreateDto): Observable<any> {
    return this.http.post<any>(this.apiUrl, agePricing);
  }

  update(id: number, agePricing: AgePricingUpdateDto): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, agePricing);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}
